import React from "react";
import { useTheme } from "../context/ThemeContext";

// Defaults to a fixed top-right corner placement (for the pre-login
// screens, which have no header bar of their own to sit in). Dashboard
// passes an override to sit inline in its own header instead.
export default function ThemeToggle({ style }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={isDark ? "Switch to Light mode" : "Switch to Dark mode"}
      style={{ ...styles.base, ...style }}
    >
      {isDark ? "☀ Light" : "🌙 Dark"}
    </button>
  );
}

const styles = {
  base: {
    position: "fixed",
    top: 14,
    right: 16,
    zIndex: 50,
    background: "var(--panel-alt)",
    border: "1px solid var(--border)",
    color: "var(--text)",
    borderRadius: 6,
    padding: "6px 12px",
    fontSize: 11.5,
    cursor: "pointer",
  },
};
